import { render } from "./tag.vue?vue&type=template&id=1a62d544&scoped=true"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"

import "./tag.vue?vue&type=style&index=0&id=1a62d544&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a62d544"

export default script